import styles from './Overlay.module.css';
import type { FC } from 'react';
import type { OverlayProps } from './Overlay.types';

export const Overlay: FC<OverlayProps> = ({
  children,
  onClose,
  isCentered,
}) => {
  return (
    <div
      className={styles.overlay}
      data-hide-on-print="true"
      data-component="Overlay"
    >
      <div className={styles.background} onClick={onClose} />
      <div className={isCentered ? styles.overlayCentered : ''}>{children}</div>
    </div>
  );
};
